import { Dispatch } from 'redux';

import ContactPersonApi from '../../api/contact-person-api';
import { checkSuccessKahlMessages, checkDangerKahlMessages, redirectToStandaloneKahl } from '../../api/request-utils';

export type Action =
  | {
      type: 'CREATE_PASSWORD_START';
    }
  | {
      type: 'CREATE_PASSWORD_SUCCESS';
      link?: string;
    }
  | {
      type: 'CREATE_PASSWORD_FAIL';
      error: string;
      code?: number;
    }
  | {
      type: 'CREATE_PASSWORD_POSTPAID_START';
    }
  | {
      type: 'CREATE_PASSWORD_POSTPAID_SUCCESS';
      link?: string;
    }
  | {
      type: 'CREATE_PASSWORD_POSTPAID_FAIL';
      error: string;
      code?: number;
    };

export const createPasswordPostpaid = (password: string, verificationSecred: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: 'CREATE_PASSWORD_POSTPAID_START'
    });

    return ContactPersonApi.createPasswordPostpaid(password, verificationSecred)
      .then(res => {
        checkSuccessKahlMessages(res.data);
        dispatch({
          type: 'CREATE_PASSWORD_POSTPAID_SUCCESS',
          link: res.data
        })
        window.location.replace(res.data);
      }
      )
      .catch(err => {
        if (err.response.status === 410 && err.response.data.resultCode) {
          redirectToStandaloneKahl(err.response.data.resultCode, 'UME_EXT')
        } else {
          checkDangerKahlMessages(err.response.data);
        }
        return dispatch({
          type: 'CREATE_PASSWORD_POSTPAID_FAIL',
          error: err.toString(),
          code: err.response && err.response.status
        });
      });
  };
};

export const createPassword = (password: string, verificationSecret: string, otp?: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: 'CREATE_PASSWORD_START'
    });

    return ContactPersonApi.createPassword(password, verificationSecret, otp)
      .then(res => {
        checkSuccessKahlMessages(res.data);
        dispatch({
          type: 'CREATE_PASSWORD_SUCCESS'
        });
        window.location.replace(res.data);
      })
      .catch(err => {
        if (err.response.status === 410 && err.response.data.resultCode) {
          redirectToStandaloneKahl(err.response.data.resultCode, 'UME_EXT')
        } else {
          checkDangerKahlMessages(err.response.data);
        }
        return dispatch({
          type: 'CREATE_PASSWORD_FAIL',
          error: err.message.toString(),
          code: err.response && err.response.status
        });
      });
  };
};
